import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  es: {
    nav: {
      home: 'Inicio',
      transport: 'Transporte',
      tourism: 'Turismo',
      nature: 'Naturaleza',
      sports: 'Deportes',
      services: 'Servicios',
      accessibility: 'Accesibilidad',
    },
    cards: {
      transport: {
        title: 'Transporte Público',
        description: 'Guaguas, tranvía y paradas',
      },
      tourism: {
        title: 'Turismo',
        description: 'Alojamientos y restaurantes',
      },
      nature: {
        title: 'Naturaleza',
        description: 'Senderos y actividades',
      },
      sports: {
        title: 'Deportes',
        description: 'Centros y eventos',
      },
      services: {
        title: 'Servicios',
        description: 'Salud y educación',
      },
    },
    common: {
      loading: 'Cargando...',
      error: 'Error al cargar los datos',
      noData: 'No hay datos disponibles',
    },
    footer: {
      poweredBy: 'Datos abiertos del Cabildo de Tenerife',
      disclaimer: 'Aplicación cívica de información pública',
    },
  },
  en: {
    nav: {
      home: 'Home',
      transport: 'Transport',
      tourism: 'Tourism',
      nature: 'Nature',
      sports: 'Sports',
      services: 'Services',
      accessibility: 'Accessibility',
    },
    cards: {
      transport: {
        title: 'Public Transport',
        description: 'Buses, tram and stops',
      },
      tourism: {
        title: 'Tourism',
        description: 'Accommodations and restaurants',
      },
      nature: {
        title: 'Nature',
        description: 'Trails and activities',
      },
      sports: {
        title: 'Sports',
        description: 'Centers and events',
      },
      services: {
        title: 'Services',
        description: 'Health and education',
      },
    },
    common: {
      loading: 'Loading...',
      error: 'Error loading data',
      noData: 'No data available',
    },
    footer: {
      poweredBy: 'Open data from Cabildo de Tenerife',
      disclaimer: 'Civic public information application',
    },
  },
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'es';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'es' ? 'en' : 'es'));
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
